import { Navigate, Route, Routes } from 'react-router';
import Index from '../pages/index';
import QuestionSets from '../pages/questionSets/pages/questionSets';
import AddQuestionsIndex from '../pages/questionSets/pages/addQuestions/index';
import { MyContentProvider } from './myContentContext';
import AddMcFillInQuestion from '../pages/AddMcFillInQuestion';
import ResourceSet from '../pages/resourceSets/components/resourceSet/resourceSet';
import QuestionsSearch from '../pages/questionSets/utils/questionSearchRoute';
import ResourceSets from '../pages/resourceSets/pages/resourceSets';
import AddCRQuestion from '../pages/questionSets/pages/AddCRQuestion';

const MyContentRoute = () => {
  return (
    <MyContentProvider>
      <Routes>
        <Route path="/" element={<Index />}>
          <Route index element={<Navigate to="questionsets" />} />
          <Route path="questionsets" element={<QuestionSets />} />
          <Route path="resourcesets" element={<ResourceSets />} />
        </Route>
        <Route path="questionsets/:setId/questions" element={<AddQuestionsIndex />} />
        <Route path="questionsets/:setId?/mc_fillInQuestion/:questionId?/:courseId?" element={<AddMcFillInQuestion />} />
        <Route path="questionsets/:setId?/cr_Question/:questionId?/:courseId?" element={<AddCRQuestion />} />
        <Route path="resourcesets/:setId" element={<ResourceSet />} />
        <Route element={<QuestionsSearch />} path="questionsets/questionsSearch/*" />

      </Routes>
    </MyContentProvider>
  );
};

export default MyContentRoute;